import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"

export type BasemapThumbnailProps = {
  className?: string
  src: string | null | undefined
  name?: string | null
}

/**
 * The chooser tile image, at table/sheet size. A basemap whose
 * Configuration names no thumbnail renders the placeholder rather than a
 * broken image — the console's chooser would show the same gap, so the
 * backoffice should make it obvious.
 */
function BasemapThumbnail(props: BasemapThumbnailProps) {
  const { src, name, className } = props

  if (!src) {
    return (
      <span
        className={cn(
          "flex h-8 w-12 items-center justify-center rounded border border-dashed text-muted-foreground",
          className,
        )}
        title="No thumbnail in the configuration"
      >
        <Icon src="image-slash" size={12} />
      </span>
    )
  }

  return (
    <img
      className={cn("h-8 w-12 rounded border object-cover", className)}
      src={src}
      alt={name ?? "Basemap thumbnail"}
    />
  )
}

export default BasemapThumbnail
